export default function createLocaleFormatter(locale) {
  return (localeToTranslate) => {
    if (typeof Intl.DisplayNames !== "function") {
      return localeToTranslate;
    }
    const languageNames = new Intl.DisplayNames([locale], {
      type: "language",
      languageDisplay: "standard"
    });
    return languageNames.of(localeToTranslate) || localeToTranslate;
  };
}
